export default {
  path: ":alias/classes",
  component: resolve => require(["@/views/classes"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/classes/list"], resolve)
    },
    {
      path: ":classId/students",
      component: resolve => require(["@/views/class-students/list"], resolve)
    },
    {
      path: ":classId/courses",
      component: resolve => require(["@/views/courses/list"], resolve)
    },
    {
      path: ":classId/courses/class-sign-ins",
      component: resolve => require(["@/views/courses/class-sign-ins"], resolve)
    },
    {
      path: "statistics",
      component: resolve => require(["@/views/courses/statistics"], resolve)
    }
  ]
};
